export default __webpack_public_path__ + "static/media/5.d035ed6a.jpeg";